import { MapPin, Navigation, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { IllustrationFrame } from './shared'

const graphicKey = 'whatsNew.slides.mapAddressSearch.graphic'

function AddressResults() {
  const { t } = useTranslation()
  return (
    <g>
      <rect x="54" y="88" width="286" height="170" rx="14" className="fill-card stroke-border" />
      <text x="72" y="116" className="fill-muted-foreground text-3xs font-semibold">
        {t(`${graphicKey}.results`)}
      </text>
      <rect x="66" y="130" width="262" height="50" rx="9" className="fill-primary/10" />
      <MapPin x="78" y="145" width="20" height="20" className="text-primary-strong" />
      <text x="108" y="159" className="fill-foreground text-2xs font-semibold">
        {t(`${graphicKey}.firstResult`)}
      </text>
      <path
        d="M108 169H252 M78 202H292 M78 216H248 M78 238H279"
        className="stroke-muted-foreground/20"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </g>
  )
}

function NavigationTarget() {
  const { t } = useTranslation()
  return (
    <g>
      <circle cx="501" cy="165" r="58" className="fill-primary/5" />
      <circle
        cx="501"
        cy="165"
        r="39"
        className="fill-none stroke-primary/30"
        strokeDasharray="4 6"
      />
      <circle cx="501" cy="165" r="24" className="fill-card stroke-primary/40" />
      <Navigation x="489" y="153" width="24" height="24" className="text-primary-strong" />
      <rect x="397" y="222" width="208" height="29" rx="14.5" className="fill-primary/10" />
      <text
        x="501"
        y="241"
        textAnchor="middle"
        className="fill-primary-strong text-3xs font-medium"
      >
        {t(`${graphicKey}.selected`)}
      </text>
    </g>
  )
}

export function MapAddressSearchIllustration() {
  const { t } = useTranslation()
  return (
    <IllustrationFrame label={t(`${graphicKey}.description`)}>
      <rect
        x="38"
        y="25"
        width="604"
        height="242"
        rx="18"
        className="fill-muted/30 stroke-border"
      />
      <path
        d="M361 112C407 90 455 104 490 77S570 48 624 64 M356 198C410 187 435 200 470 187S552 147 629 162 M410 38V267 M570 38V267"
        className="fill-none stroke-border"
        strokeWidth="7"
      />
      <rect x="54" y="39" width="286" height="40" rx="11" className="fill-card stroke-primary/40" />
      <Search x="69" y="51" width="17" height="17" className="text-primary-strong" />
      <text x="98" y="64" className="fill-foreground text-xs font-medium">
        {t(`${graphicKey}.query`)}
      </text>
      <AddressResults />
      <path d="M340 155H417" className="fill-none stroke-primary/50" strokeWidth="1.5" />
      <circle cx="417" cy="155" r="4" className="fill-primary" />
      <NavigationTarget />
    </IllustrationFrame>
  )
}
